<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@sendMessage">Send Message</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialogIcon">close</mat-icon>
</div>

@if (invalidNames) {
  <div class="error invalid-cridentials d-flex justify-content-center align-items-center">
    <mat-icon class="mr-8" i18n-label="@@errorIcon">error</mat-icon>
    <span i18n="@@invalidNamesMessage" >Please enter names to proceed!</span>
  </div>
}

<mat-dialog-content>
  <form [formGroup]="sendEmailForm">
    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-chip-grid #chipList aria-label="Name selection">
          @for (name of names; track name) {
            <mat-chip-row
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(name)">
              {{name}}
              @if (removable) {
                <mat-icon matChipRemove i18n-label="@@removeChipIcon">cancel</mat-icon>
              }
            </mat-chip-row>
          }
          <input
            data-testid="send_email_names"
            placeholder="Name"
            i18n-placeholder="@@namePlaceholder"
            #nameInput
            [formControl]="nameCtrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysNames"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-grid>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          @for (name of filteredNames | async; track name) {
            <mat-option [value]="name" i18n-label="@@nameOption">
              {{name}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@messageTitleLabel">Message title</mat-label>
        <input data-testid="send_email_title" matInput id="title" i18n-placeholder="@@messageTitlePlaceholder" placeholder="Message title" name="title" formControlName="title" required />
        <mat-error>
          @if (!sendEmailForm.get('title').valid && sendEmailForm.get('title').touched) {
            @if (sendEmailForm.get('title').errors && sendEmailForm.get('title').errors['required'] || sendEmailForm.get('title').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@messageLabel">Message</mat-label>
        <input data-testid="send_email_last_name" matInput id="message" i18n-placeholder="@@messagePlaceholder" placeholder="Message" name="message" formControlName="message" required />
        <mat-error>
          @if (!sendEmailForm.get('message').valid && sendEmailForm.get('message').touched) {
            @if (sendEmailForm.get('message').errors && sendEmailForm.get('message').errors['required'] || sendEmailForm.get('message').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div>
      <button i18n="@@send" data-testid="send_email_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Send</button>
    </div>
  </form>
</mat-dialog-content>